//
//
//
//
//
//
//
//
//
//
//
//
//

import utils from './utils/index'
export default {
  name: 'home',
  data () {
    return {
      isMobileEnv: utils.isMobileEnv
    }
  },
  mounted () {},
  components: {
    customePcNav: () => import('@/components/pc/nav'),
    customPcFooter: () => import('@/components/pc/footer')
  }
}



// WEBPACK FOOTER //
// ./src/App.vue